import { render } from "./VerbMenu.vue?vue&type=template&id=6a6759c0&bindings={\"picked\":\"props\",\"thingHoveredOn\":\"props\",\"recommendedVerb\":\"props\",\"verbList\":\"options\"}"
import script from "./VerbMenu.vue?vue&type=script&lang=js"
export * from "./VerbMenu.vue?vue&type=script&lang=js"

import "./VerbMenu.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script